<template>
    <div>
        <div class="row data-form">
            <div class="col-12 col-md-12">
                <ValidationObserver ref="updateForm">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('excel_file')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="defineForm.file"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     multiple
                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex">
                            <DownloadExcelTemplate :code="'student_programs_graduation'"/>
                            <b-button variant="primary"
                                      @click="sendForm"
                                      label="import"
                            />
                        </div>

                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>
<script>
// Component


// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import JobService from "@/services/JobService";
import excelImportTemplate from "@/services/ExcelImportTemplate";
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";

export default {
    components: {
        DownloadExcelTemplate,

        ValidationProvider,
        ValidationObserver
    }
    ,
    data() {
        return {
            defineForm: {
                semester_id: null,
                file: null
            },
            loading: false,
            tableFields: [
                {
                    key: 'departmental_elective_ects_credit',
                    label: this.$t('sample_template_excel'),
                    tdClass: 'border text-center',
                },
                {
                    key: 'non_departmental_elective_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ge_selective_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'dge_elective_number_ects_credits',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'non_departmental_elective_ects_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ge_elective_ects_credit',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_dep',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_non_dep',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'graduation_generage',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'ects_credits',
                    label: '',
                    tdClass: 'border text-center',
                },
                {
                    key: 'credit',
                    label: '',
                    tdClass: 'border text-center',
                },



            ],
            tableItems: [
                {
                    departmental_elective_ects_credit: this.$t('departmental_elective_ects_credit'),
                    non_departmental_elective_credit: this.$t('non_departmental_elective_credit'),
                    ge_selective_credit: this.$t('ge_selective_credit'),
                    dge_elective_number_ects_credits: this.$t('dge_elective_number_ects_credits'),
                    non_departmental_elective_ects_credit: this.$t('non_departmental_elective_ects_credit'),
                    ge_elective_ects_credit: this.$t('ge_elective_ects_credit'),
                    graduation_dep: this.$t('graduation_dep'),
                    graduation_non_dep: this.$t('graduation_non_dep'),
                    graduation_generage: this.$t('graduation_generage'),
                    ects_credits: this.$t('ects_credits'),
                    credit: this.$t('credit'),



                },
            ]
        }
    }
    ,
    methods: {
        async sendForm() {
            const isValid = await this.$refs.updateForm.validate();
            if (isValid) {
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])
                return JobService.studentProgramsGraduationRequirement(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.defineForm.file=null
                        this.$router.push('/job/logs/detail/' + response.data.data.log_id)
                        this.$emit('successProcess',true)
                    })
                    .catch(e => {
                        this.showErrors(e,this.$refs.updateForm)
                    })
            }
        },

    }
}
</script>
